import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import api from '../services/api';
import axios from 'axios';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await api.get('/notifications/', {
        params: { unread_only: true, per_page: 5 }
      });
      console.log('Fetched notifications - General:', response.data);
      setNotifications(response.data.items || []);
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/auth/login');
  };

  return (
    <div className="h-screen flex overflow-hidden bg-gray-100">
      {/* Sidebar for mobile */}
      <div className={`md:hidden ${sidebarOpen ? 'fixed inset-0 flex z-40' : 'hidden'}`}>
        <div className="fixed inset-0" onClick={() => setSidebarOpen(false)}>
          <div className="absolute inset-0 bg-gray-600 opacity-75"></div>
        </div>
        <div className="relative flex-1 flex flex-col max-w-xs w-full bg-white">
          <Sidebar user={user} onClose={() => setSidebarOpen(false)} />
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div className="flex flex-col w-64">
          <Sidebar user={user} />
        </div>
      </div>

      {/* Main content - FIXED: Removed width constraints */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header
          user={user}
          notifications={notifications}
          onMenuClick={() => setSidebarOpen(true)}
          onLogout={handleLogout}
          onNotificationClick={(notification) => {
            // Handle notification click
          }}
        />

        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          {/* FIXED: Removed max-w-7xl constraint to allow full width */}
          <div className="py-6 px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;